import {Tabs} from 'antd';
import {AllBatchView} from "./AllBatchView";
import {UserTab} from "../user/UserTab";

export const AdminTab = ({refresh, onRefresh, onApiFail, props}) => {
    const items = [
        {
            key: 'Users',
            label: 'Users',
            children: <UserTab refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        }
    ];

    const onTabChange = () => {
    }

    const onClick = () => {
    }

    return <Tabs defaultActiveKey={'Users'} tabPosition={'left'} items={items} onChange={onTabChange} onTabClick={onClick}/>
}